import { useTranslator } from '@bluebeam/react-i18n';
import AppStoreContext from 'contexts/AppStoreContext';
import React, { FC, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { StudioProjectFolder } from '../../records/StudioProjectFolder';
import SelectDestinationToExport from './SelectDestinationToExport';
import { ModalState } from '../../records/ModalState';
import ExportDataModal from '../../components/modals/ExportDataModal/ExportDataModal';

const ExportDataPage: FC = () => {
  const history = useHistory();

  const { translate } = useTranslator(['buttons']);
  const { actions, state } = useContext(AppStoreContext);

  const [exportToDestination, setExportToDestination] = useState({
    integrations: false,
    studio: false,
  });

  useEffect(() => {
    actions.resetBreadcrumbs();
    actions.resetStudioView();
    actions.resetIntegrationsView();
    actions.resetIntegrationsSelectedItems();
    actions.setStudioSelectedFiles([]);
    actions.setStudioSelectedFolders([]);
    actions.setStudioExportFolder(new StudioProjectFolder());
    actions.clearStudioNavigation();
    getConnectedAccounts();
  }, []);

  const getConnectedAccounts = async (): Promise<void> => {
    await actions.getConnectedAccounts();
  };

  const handleOnNextClick = (evt: React.MouseEvent<HTMLElement>): void => {
    evt.stopPropagation();

    const destination = exportToDestination.studio ? 'studio' : 'integrations';

    const modalState = new ModalState({
      id: 'launchExportDataModal',
      portal: 'main',
      open: true,
      overlayClassName: 'modal__overlay',
      props: {
        exportTo: destination,
      },
      component: ExportDataModal,
    });

    actions.createModal(modalState);
  };

  const isDisabled = (): boolean => {
    if (!(exportToDestination.integrations || exportToDestination.studio)) {
      return !(exportToDestination.integrations || exportToDestination.studio);
    }

    return false;
  };

  const handleGoBack = async () => {
    await actions.clearIntegrationsNavigation();
    await actions.setStudioExportFolder(null);
    await actions.setStudioProjectId('');
    await actions.resetBreadcrumbs();
    await actions.clearAllModals();
    await actions.clearStudioNavigation();
    history.replace(`/project/${state.selectedProject}/settings`);
  };

  return (
    <div id="export-project-data" className="p-5">
      <SelectDestinationToExport
        onChange={setExportToDestination}
        onBackClick={handleGoBack}
      />
      <div
        className="row so-vw100 w100 bgd-white-2 justify-between"
        style={{ maxHeight: '84vh' }}
      >
        <button
          id="integrations-modal-submit"
          className="btn btn-primary"
          disabled={isDisabled()}
          onClick={handleOnNextClick}
        >
          {translate('buttons:next')}
        </button>
      </div>
    </div>
  );
};

export default ExportDataPage;
